export interface DefaultComment {
  com_geb_naam: string;
  com_commentaar: string;
  created_at?: string;
  updated_at?: string;
  com_geb_id: number;
  company?: string;
  com_extra_id?: number;
  com_project_id?: number;
  attachments?: number;
}

export interface CreateCommentInput {
  body: string;
  userId: number;
  userName: string;
  company?: string;
}

export interface CreateProjectTaskCommentInput {
  body: string;
  userId: number;
  userName: string;
  taskId: number;
  projectId: number;
  company?: string;
}

export const mapToComment = ({
  body,
  userId,
  userName,
  company,
}: CreateCommentInput): DefaultComment => {
  return {
    com_geb_naam: userName,
    com_commentaar: body,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    com_geb_id: userId,
    company: company || '',
  };
};

export const mapToProjectTaskComment = ({
  body,
  userId,
  userName,
  taskId,
  projectId,
  company,
  attachments,
}: CreateProjectTaskCommentInput): DefaultComment => {
  return {
    com_geb_naam: userName,
    com_commentaar: body,
    com_geb_id: userId,
    com_extra_id: taskId,
    com_project_id: projectId,
    company: company,
    attachments: attachments,
  };
};
